import React from 'react'

const Flag = ({flagURL}) => {
  return (<div>
    <img src={flagURL} width="80" alt="Flag" />
  </div>)
}

export default Flag